import { fetchStyleList } from './fetchStyleList';
import { fetchThemes } from './fetchThemes';

export const actions = {
  fetchStyleList,
  fetchThemes,
};
